module.exports = __webpack_public_path__ + "static/img/1113503.0d70e35e.gif";